import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  activateHandsetLayout$ = this.getActivateHandsetLayout();
  activateWebLayout$ = this.getActivateWebLayout();

  constructor(
    private breakpointObserver: BreakpointObserver
  ) { }

  private getActivateHandsetLayout(): Observable<boolean> {
    return this.breakpointObserver.observe([Breakpoints.Handset]).pipe(
      map(result => result.matches),
      shareReplay(1)
    );
  }

  private getActivateWebLayout(): Observable<boolean> {
    return this.breakpointObserver.observe([Breakpoints.Web]).pipe(
      map(result => result.matches),
      shareReplay(1)
    );
  }
}
